import React, {Component} from 'react';
import './agile.css';


class AgileComponent extends Component {

    render() {
        return (
          <div className="agile">
              <p className="headline">Agile development</p>
              <p className="text-justify">
                Excellent results can be achieved through agility.
                Therefore I try to empower the agile concept in any aspects of life.
                I believe that brilliant software can only be achieved through constant feedback and an open mind.
                Self-organization of teams triggers creativity.
                <br /> <br />
                Through working experience, I have become an expert on Scrum.
                I have worked with JIRA, Open-Office and classic tools like post-its.
              </p>
          </div>
        );
    }
}

export default AgileComponent;



// WEBPACK FOOTER //
// ./src/components/agile/agile.jsx